import { FC } from 'react'
import { ITicket } from '../../model/ITicket'
import { ticketApi } from '../../api/ticket.api'
import TextButton from '../common/buttom/TextButton'
import InfoWidget from '../common/widgets/InfoWidget'
import { useTicket } from '../../hooks/useTicket'

const RelatedTickets: FC<{ orderId?: ITicket['orderId']; ticketId?: ITicket['id'] }> = ({
  orderId,
  ticketId,
}) => {
  const { data: tickets } = ticketApi.useGetRelatedTicketsQuery(orderId || '', {
    skip: !orderId,
  })
  const { addTicketById } = useTicket()

  return !orderId || !tickets?.content?.length || tickets.content.length === 1 ? null : (
    <div className=''>
      <InfoWidget className='my-2' title='Related Tickets'>
        {tickets.content
          .filter(({ id }) => id !== ticketId)
          .map(({ id, type }) => (
            <TextButton key={`RelatedTicket-${id}`} onClick={() => addTicketById(id)}>
              {id} ({type?.name || ''})
            </TextButton>
          ))}
      </InfoWidget>
    </div>
  )
}

export default RelatedTickets
